export const ANON_DISPLAY_BANNER = "ANON_DISPLAY_BANNER";
export const USER_DISPLAY_BANNER = "USER_DISPLAY_BANNER";
export const DESIGN_PROFILE_NO_ADDRESS = "DESIGN_PROFILE_NO_ADDRESS";
export const DISPLAY_SMALL_LOT_SIZE_V2 = "DISPLAY_SMALL_LOT_SIZE_V2";
export const DISPLAY_SMALL_LOT_SIZE_AS_DEFAULT_VALUE_V2 =
  "DISPLAY_SMALL_LOT_SIZE_AS_DEFAULT_VALUE_V2";
export const PREMIUM_PACKAGE_FULL_YARD_V2 = "PREMIUM_PACKAGE_FULL_YARD_V2";
export const UBER_PREMIUM_V2 = "UBER_PREMIUM_V2";
export const AA_TEST = "AA_TEST";
export const SKIP_DP_QUIZ_LANDING_PAGE = "SKIP_DP_QUIZ_LANDING_PAGE";
export const PROMO_CODE_FROM_DESIGN_PROFILE = "PROMO_CODE_FROM_DESIGN_PROFILE";
export const EXTERIOR_ADD_ONS_ENABLE = "EXTERIOR_ADD_ONS_ENABLE";

// IMPORTANT:
// Make sure to put your split in the correct traffic type when creating it on split.io!
// Client-dashboard has two traffic types: anonymous (pre-purchase) and user (anything in onboarding)

const anonymousSplits: string[] = [
  AA_TEST,
  ANON_DISPLAY_BANNER,
  DISPLAY_SMALL_LOT_SIZE_V2,
  DISPLAY_SMALL_LOT_SIZE_AS_DEFAULT_VALUE_V2,
  PREMIUM_PACKAGE_FULL_YARD_V2,
  UBER_PREMIUM_V2,
  DESIGN_PROFILE_NO_ADDRESS,
  SKIP_DP_QUIZ_LANDING_PAGE,
  PROMO_CODE_FROM_DESIGN_PROFILE,
  EXTERIOR_ADD_ONS_ENABLE,
];

const userSplits: string[] = [USER_DISPLAY_BANNER];

export { anonymousSplits, userSplits };
